import React from 'react'
import Manager from '../../../public/components/Manager'
import SupplierEvaluateDiv from './SupplierEvaluateDiv'
Ext.require('Ext.Toast')

const config = {
    tabs:
    {
        退回评价: {
            buttons: [],
            columns: [
                { _text: '评价编号', field: 'SupplierEvaluateApply.Number', search: true, flex: 1, locked: false },
                { _text: '供应商名称', field: 'SupplierName', search: true, flex: 1 },
                { _text: '申请原因', field: 'SupplierEvaluateApply.Reason', flex: 1 },
                { _text: '退回原因', field: 'ReturnReason', flex: 1, flex: 1 },
            ],
            onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierEvaluateDiv {...props} id={data.id} />),
        },
        已完成: {
            buttons: [],
            columns: [
                { _text: '评价编号', field: 'SupplierEvaluateApply.Number', search: true, flex: 1, locked: false },
                { _text: '供应商名称', field: 'SupplierName', search: true, flex: 1 },
                { _text: '申请原因', field: 'SupplierEvaluateApply.Reason', flex: 1 },
            ],
            onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierEvaluateDiv {...props} id={data.id} readOnly={true} />),
        },
    }
}

export default props => <Manager {...props} config={config} />